<template>
  <div>
    <breadcrumbs home="Cask"/>

      <v-card flat>
        <v-form v-model="valid" ref="form">
          <v-container class="pt-6 px-6 purtrak-scrollable" fluid>
            <v-row dense>
              <v-col cols="6" sm="2">
                <v-text-field label="Number" v-model="cask.number" :rules="[fieldRules.required,fieldRules.maxLength(10)]" :counter="10" outlined dense/>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6" sm="2">
                <decimal-number-input label="Empty weight" v-model="cask.tare" prefix="" suffix="kg" :precision="3"/>
              </v-col>
              <v-col cols="6" sm="2">
                <decimal-number-input label="Weight" v-model="cask.fillWeight" prefix="" suffix="kg" :precision="3"/>
              </v-col>
<!--
              <v-col cols="6" sm="2">
                <decimal-number-input label="Strength" x-model="cask.fillStrength" prefix="" suffix="% alc./vol." :precision="2" :max="99.99"/>
              </v-col>
-->
            </v-row>
            <v-row dense align="center" v-if="!!caskId">
              <v-col cols="6" sm="2">
                <v-tooltip bottom open-delay="1000"  nudge-top="20">
                  <template v-slot:activator="{on}">
                    <div v-on="on">
                      <v-checkbox label="Retired" v-model="cask.retired" dense class="mt-n2"/>
                    </div>
                  </template>
                  A retired cask cannot be chosen to refill
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="4" v-if="sites.length>1 && caskId === undefined">
                <v-autocomplete v-model="cask.initial.siteId" outlined dense label="Site"
                                :items="sites" item-text="name" item-value="id"/>
              </v-col>
              <v-col cols="6" sm="2">
                <v-text-field label="Location" v-model="cask.location" :rules="[fieldRules.maxLength(20)]" :counter="20" outlined dense
                      hint="e.g. rack, pallet"/>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6">
                <v-text-field label="Info" v-model="cask.info" :counter="200" :rules="[fieldRules.maxLength(200)]" outlined dense
                        hint="e.g. cask origin, char level"/>
              </v-col>
            </v-row>

<!--
            <v-row dense v-if="caskId!=undefined && cask.contents.volume>0">
              <v-col cols="6" sm="2">
                <decimal-number-input label="Strength" x-model="cask.fillStrength" prefix="" suffix="% alc./vol." :precision="2"/>
              </v-col>
              <v-col cols="6" sm="2">
                <decimal-number-input label="Weight" v-model="cask.fillWeight" prefix="" suffix="kg" :precision="3"/>
              </v-col>
            </v-row>
-->

            <v-row v-if="values && connectedToAccounting" dense>
              <v-col cols="12" sm="4">
                <account-picker v-model="cask.inventoryAccountRef" label="Inventory asset account"
                                :accounts="accounts" :addTypes="['OtherCurrentAsset']"
                                hint="The inventory account used to track the value of this cask's contents"/>
              </v-col>
            </v-row>

            <v-row v-if="caskId==undefined">
              <v-col cols="12" sm="7">
                <excise-vessel-initial :initial="cask.initial" :expand="false" date-label="Fill date/time" spiritsOnly/>
              </v-col>
            </v-row>

          </v-container>
        </v-form>

        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer/>
          <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
          <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>

    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import {format} from 'date-fns'
import ExciseVesselInitial from '@/views/equipment/exciseVessel/ExciseVesselInitial'
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'InventoryCasksEdit',
  mixins: [confirmLeave],
  components: {ExciseVesselInitial},
  props: {
    caskId: {type:String, required:false}
  },
  data () {
    return {
      accounts: [],
      cask: {number:'0',tare:0,location:'',info:'',inventoryAccountRef:'',fillWeight:0,retired:false,
             contents: {},
             initial:{siteId:'',date:format(new Date(), 'yyyy-MM-dd HH:mm:ss'),lot:'',alcoholId:'',volume:0,litres:0,kg:0,strength:0,value:0}},
      dirty: false,
      saving: false,
      loading: false,
      valid: true
    }
  },
  computed: {
    sites() {
      return this.$store.getters.sites(true, {B265:true,B266:true});
    },
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    },
    values() {
      return this.$store.getters.company.permissions.includes('values') && this.$store.getters.company.settings.useAccounts;
    }
  },
  watch: {
    cask: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },
  async created() {
    this.loading = true;
    const results = await this.$apiCall(`query InventoryCasksEdit($currency:String!, $accounting:Boolean!,$edit:Boolean!,$caskId:ID!) {
                                              accounts(currency:$currency) @include(if:$accounting) {
                                                ref,name,type
                                              }
                                              cask(id:$caskId) @include(if:$edit) {
                                                id,number,tare,location,inventoryAccountRef,info,fillWeight,retired
                                                contents {volume}
                                              }
                                              nextCaskNumber @skip(if:$edit)
                                              companyAccounts @skip(if:$edit) {caskInventory}
                                            }`,
                                        {accounting:this.connectedToAccounting, currency:this.$store.getters.company.settings.homeCurrency,
                                         edit:this.caskId!=undefined,caskId:this.caskId || ''});
    if (results.error) {
      this.$nextTick(() => this.dirty = false);
      this.$router.back();
      return;
    }
    if (this.connectedToAccounting)
      this.accounts = results.data.accounts.filter(account => account.type === 'OtherCurrentAsset');

    if (this.caskId)
      this.cask = results.data.cask;
    else {
      Object.assign(this.cask, {number:results.data.nextCaskNumber,inventoryAccountRef:results.data.companyAccounts.caskInventory});
      this.cask.initial.siteId = this.sites[0].id;
      this.$refs.form.validate();
    }
    this.$nextTick(() => this.dirty = false);
    this.loading = false;
  },

  methods: {
    cancel() {
      this.$router.back();
    },
    async save() {
      if (!this.valid) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }
      this.saving = true;
      // eslint-disable-next-line no-unused-vars
      const {contents, ...input} = this.cask;
      if (this.cask.id)
        delete input.initial;
      const results = await this.$apiCall(`mutation InventoryCasksEdit($input: CaskInput!) {
                                             caskCreate(input:$input) {id}
                                           }`,
                                          {input})
      this.saving = false;
      if (!results.error) {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.cask.id?'Updated':'Created'} Cask ${this.cask.number}`});
      }
    }
  }
}
</script>